import { render, staticRenderFns } from "./autenticar-anses.vue?vue&type=template&id=7f85a51a"
import script from "./autenticar-anses.vue?vue&type=script&lang=js"
export * from "./autenticar-anses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports